import SC from "./style";
import { Button } from "@InnoUI/";
import theme from "@theme/";
import { useState } from "react";
import InnoIcons from "@InnoIcons/";
import { apiPost } from "api/callApi";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import axios from "axios";
import { readFromLocalStorage, showAlert } from "utils/helper";

const FileReport = () => {
  const currentDate = dayjs(); // Current date
  const previousMonthDate = currentDate.subtract(1, "month"); // Previous month

  const [searchdate, setSearchdate] = useState({
    startDate: previousMonthDate.format("YYYY-MM-DD"),
    endDate: currentDate.format("YYYY-MM-DD"),
  });
  const [loading, setLoading] = useState(false);

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const handleDateChange = (name, value) => {
    const formattedDate = value ? dayjs(value).format("YYYY-MM-DD") : "";
    setSearchdate((prev) => ({ ...prev, [name]: formattedDate }));
  };

  const {
    REACT_APP_BASE_URL: baseURL,
    REACT_APP_REQUEST_TIMEOUT: timeout,
    REACT_APP_API_KEY,
  } = process.env;

  let accessToken = REACT_APP_API_KEY;
  let userAuth = readFromLocalStorage("userAccessToken");
  let BASE_URL = baseURL || `${window.location.origin}/api`;
  userAuth = userAuth === null ? "" : userAuth;

  const generatePdf = async () => {
    // if (!searchdate.startDate || !searchdate.endDate) {
    //   showAlert("Warning", "Please Provide Date Range", "warning");
    // }

    try {
      setLoading(true);
      let endpoint = `/v1/report/filereport`;
      const url = BASE_URL + endpoint;
      const requestTimeout = timeout ? parseInt(timeout, 10) * 1000 : 180000;
      const response = await axios.post(
        url,
        {
          projectId: currentProject.id,
          startDate: searchdate.startDate,
          endDate: searchdate.endDate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            api_key: accessToken,
            Authorization: `Bearer ${userAuth}`,
          },
          timeout: requestTimeout,
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const now = new Date();
        const datePart =
          now.getFullYear().toString() +
          String(now.getMonth() + 1).padStart(2, "0") +
          String(now.getDate()).padStart(2, "0");
        const timePart =
          String(now.getHours()).padStart(2, "0") +
          String(now.getMinutes()).padStart(2, "0");
        const projectName = currentProject?.propertyName || "Report";
        const fileName = `${projectName} - File Report - ${datePart} - ${timePart}.pdf`;

        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = downloadUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(downloadUrl);
        }, 300);
        setLoading(false);
      } else {
        showAlert({ title: "Error", text: "Failed to generate PDF", icon: "error" });
        setLoading(false);
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      showAlert({ title: "Error", text: "Error generating PDF", icon: "error" });
      setLoading(false);
    }
  };

  const renderDatePicker = (name, placeholder, disabledDate) => (
    <DatePicker
      name={name}
      placeholder={placeholder}
      value={searchdate[name] ? dayjs(searchdate[name], "YYYY-MM-DD") : null}
      format="YYYY-MM-DD"
      onChange={(value) => handleDateChange(name, value)}
      mode="date"
      showTime={false}
      allowClear={true}
      style={{
        width: "200px",
        maxWidth: "100%",
        height: "40px",
        margin: "8px 0",
        borderRadius: "8px",
        border: "1px solid rgba(227, 110, 0, 0.2)",
      }}
      disabledDate={disabledDate}
    />
  );
  return (
    <SC.ReportContainer>
      <SC.LabelContainer>
        <SC.Label>
          Select Timeframe <SC.Astrik>*</SC.Astrik>
        </SC.Label>
        <SC.Children>
          <SC.Wrapper>
            {renderDatePicker("startDate", "Start date")}
            {renderDatePicker(
              "endDate",
              "End date",
              (current) =>
                current && current < dayjs(searchdate.startDate, "YYYY-MM-DD")
            )}
          </SC.Wrapper>
        </SC.Children>
      </SC.LabelContainer>

      <SC.ButtonContainer>
        <SC.StyledButton onClick={generatePdf} disabled={loading}>
          <InnoIcons.DownloadIcon
            sx={{
              fontSize: "18px",
              color: "white",
              marginRight: "8px",
              marginBottom: "-4px",
            }}
          />
          {loading ? "Downloading..." : "File Report"}
        </SC.StyledButton>
      </SC.ButtonContainer>
    </SC.ReportContainer>
  );
};

export default FileReport;
